import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../utils/api';
import { displayName } from '../../utils/userLabel';
import * as S from '../specimens/styles';

/*
 * Who one may write to (GET /chat/people?q=): a search box and the matches,
 * each a button. `multiple` keeps a set of chosen people as removable chips;
 * otherwise a press calls `onPick(person)` at once. `exclude` hides ids (the
 * people already in a group).
 */
export default function PeoplePicker({ multiple = false, chosen = [], onPick, onRemove, exclude = [] }) {
  const { t } = useTranslation(['chat', 'common']);
  const [q, setQ] = useState('');
  const [found, setFound] = useState([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    const timer = setTimeout(() => {
      api.get('/chat/people', { params: { q } })
        .then((r) => { if (live) { setFound(r.data?.people || []); setFailed(false); } })
        .catch(() => { if (live) setFailed(true); });
    }, 250);
    return () => { live = false; clearTimeout(timer); };
  }, [q]);

  const hidden = new Set([...exclude, ...chosen.map((p) => p.user_id)]);
  return (
    <div>
      {multiple && chosen.length > 0 && (
        <ul aria-label={t('chosen')} style={{ listStyle: 'none', padding: 0, margin: '0 0 8px', display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {chosen.map((p) => (
            <li key={p.user_id}>
              <button type="button" onClick={() => onRemove?.(p)} title={t('tip.unchoose')} data-testid="chat-chosen"
                style={{ ...S.ghostBtn, padding: '2px 10px', fontSize: 13, borderRadius: 999 }}>
                {displayName(p.name, t)} ✕
              </button>
            </li>
          ))}
        </ul>
      )}
      <label style={S.label}>
        {t('searchPeople')}
        <input type="search" value={q} onChange={(e) => setQ(e.target.value)} style={S.input}
          placeholder={t('searchPeopleHint')} data-testid="chat-people-search" autoComplete="off" />
      </label>
      {failed && <p role="alert" style={S.error}>{t('loadFailed')}</p>}
      <ul style={{ listStyle: 'none', padding: 0, margin: '8px 0 0', maxHeight: 240, overflowY: 'auto' }}>
        {found.filter((p) => !hidden.has(p.user_id)).map((p) => (
          <li key={p.user_id}>
            <button type="button" onClick={() => onPick(p)} data-testid="chat-person"
              style={{ width: '100%', textAlign: 'start', background: 'none', border: 'none', padding: '8px 4px',
                cursor: 'pointer', color: 'var(--c-text-fg)', borderBottom: '1px solid var(--c-border)', font: 'inherit' }}>
              {displayName(p.name, t)} <span style={S.hint}>@{p.username}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
